<template>
  <div class="sendReview">
    <SOSlotBase :container-name="`sendReview`" :loading="isLoading">
      <template v-slot:title-bar>
        <SOTitleBar :page-title="'Ulasan Anda'" :type="'back'" @back="back" />
      </template>

      <template v-slot:content>
        <br />
        <QuestionUlasan :idTraining="params_Idtraining" />
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase.vue";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar.vue";
import QuestionUlasan from "../components/QuestionUlasan.vue";

export default {
  name: "SendReview",
  components: {
    SOSlotBase,
    SOTitleBar,
    QuestionUlasan,
  },

  data() {
    return {
      isLoading: false,
      params_Idtraining: this.$route.params.idtraining,
    };
  },

  methods: {
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
